import tmdb from './client';

const Video = (id, config = {}) =>
  tmdb.get(`/movie/${id}/videos`, {
    ...config,
    params: { language: 'en-US', ...(config.params || {}) },
  });

export default Video;
